import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PostPlatformPreview } from 'components';
import moment from 'moment';
import * as styles from './Group.scss';
import { orgInitialState, setSelectedLinkedinPreviewType, setSelectedPreviewTab } from 'redux/modules/groupPostCompose';
var GroupPostPreview = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    config: state.config,
    groupPost: state.groupPostCompose,
    organization: state.organization.current,
    organizationId: state.organization.current.id,
    user: state.auth.user
  };
}, {
  setSelectedLinkedinPreviewType: setSelectedLinkedinPreviewType,
  setSelectedPreviewTab: setSelectedPreviewTab
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(GroupPostPreview, _Component);

  var _super = _createSuper(GroupPostPreview);

  function GroupPostPreview(props) {
    var _this;

    _classCallCheck(this, GroupPostPreview);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleTabChange", function (tab) {
      _this.props.setSelectedPreviewTab(tab.title, _this.props.organizationId);
    });

    _this.state = {
      postPreviewTabs: [{
        title: 'Facebook',
        icon: 'fa-facebook',
        selected: true
      }, {
        title: 'X (Twitter)',
        icon: 'fa-twitter'
      }, {
        title: 'LinkedIn',
        icon: 'fa-linkedin'
      }]
    };
    return _this;
  }
  /** *********************************************************
   EVENT HANDLERS
   ***********************************************************/


  _createClass(GroupPostPreview, [{
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var groupPost = this.props.groupPost;
      var videos = groupPost.videoUrl && groupPost.postType === 'videoPost' ? [groupPost.videoUrl] : [];
      return /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'absolute'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'fixed',
          maxWidth: 527,
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 10
        }
      }, /*#__PURE__*/React.createElement("div", null, this.props.groupPost.selectedPreviewTab === 'LinkedIn' && this.props.groupPost.images && this.props.groupPost.images.length > 1 && /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 24
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.postDateTime
      }, /*#__PURE__*/React.createElement("i", null, "LinkedIn does not currently support multi-image posts."))), /*#__PURE__*/React.createElement(PostPlatformPreview, {
        groupPost: true,
        images: groupPost.postType === 'linkPost' && groupPost.linkData.image ? [groupPost.linkData.image] : groupPost.images,
        videos: videos,
        messages: groupPost.messages,
        platforms: ['facebook', 'linkedin', 'twitter'],
        link: groupPost.postType === 'linkPost' ? groupPost.linkData.link : null,
        linkTitle: groupPost.linkData.title,
        linkDescription: groupPost.linkData.description,
        linkCaption: groupPost.linkData.caption,
        postDate: moment(groupPost.publishAt),
        postType: groupPost.postType
      })))));
    }
  }]);

  return GroupPostPreview;
}(Component)) || _class);
export { GroupPostPreview as default };